import { useNavigate, useLocation } from "react-router-dom";
import logoFull from "../../../../assets/logo-white-bg.png";
import { useTranslation } from "react-i18next";
import MFrame from "@/components/ui/atoms/MFrame";
import { MButton } from "@/components/ui/atoms/MButtons";
import { useManagedMembersContext } from "@/context/ManagedMembersContext";

export default function InviteRegistrationSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { fetchManagedMembers } = useManagedMembersContext();
  const name = location.state?.name || "";
  const inviterName = location.state?.inviterName || "";
  const trialEndDate = location.state?.trialEndDate || null;
  const planType = location.state?.planType || 'trial';
  const showFormNext = location.state?.showFormNext || false;
  const tokenData = location.state?.tokenData || null;
  const email = location.state?.email || null;
  const mobile = location.state?.mobile || null;
  const dialCode = location.state?.dialCode || null;
  const inviteSelection = location.state?.inviteSelection || null;

  const handleGetStarted = async () => {
    // If this is the intermediate page (before form), go to signupconfirm form
    if (showFormNext) {
      navigate('/register/signupconfirm', {
        state: {
          email,
          mobile,
          dialCode,
          inviteToken: tokenData?.token,
          tokenData,
          skipInviteOptions: true,
          inviteSelection,
        },
      });
      return;
    }

    await fetchManagedMembers(true);
    
    // If joining family (inviterName exists), go to success page first
    if (inviterName) {
      navigate("/register/success", {
        state: { 
          firstName: name, 
          inviterName,
          isJoiningFamily: true 
        },
      });
    } else {
      // If creating own family, go to success page with trial/plan info
      navigate("/register/success", {
        state: {
          firstName: name,
          trialEndDate,
          planType,
        },
      });
    }
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-success-onboarding-gradient curvy-gradient-form">
      <div className="onboarding-ellipses">
          <div className="ellipse-onboarding-success ellipse-1"></div>
          <div className="ellipse-onboarding-success ellipse-2"></div>
          <div className="ellipse-onboarding-success ellipse-3"></div>
          <div className="ellipse-onboarding-success ellipse-4"></div>
          <div className="ellipse-onboarding-success ellipse-5"></div>
        </div>
      <div className="auth-root relative overflow-hidden">
        <div className="auth-success-logo select-none">
          <img
            src={logoFull}
            alt="Maatra Logo"
            className="object-contain w-full h-full"
            draggable={false}
          />
        </div>

        {inviterName ? (
          <>
            <h1 className="heading-h6-bold mt-[64px] text-left w-full">
              {t("onboarding.inviteSuccess.title", { name })}
            </h1>
            <p className="auth-invite-success-description">
              {t("onboarding.inviteSuccess.description", {
                name: inviterName.split(" ")[0],
              })}
            </p>
            <MFrame className="w-full p-0 mt-[64px]">
              <div className="auth-invite-intro">
                <h2 className="auth-invite-intro-title">
                  {t("onboarding.inviteSuccess.introTitle")}
                </h2>
                <ul className="auth-invite-intro-list">
                  <li>{t("onboarding.inviteSuccess.benefit1")}</li>
                  <li>{t("onboarding.inviteSuccess.benefit2")}</li>
                  <li>{t("onboarding.inviteSuccess.benefit3")}</li>
                </ul>
              </div>
            </MFrame>
          </>
        ) : (
          <>
            <h1 className="heading-h6-bold mt-[64px] text-left w-full">
              {t("onboarding.inviteSuccess.familyOwnerTitle", { name })}
            </h1>
            <p className="auth-invite-success-description">
              {t("onboarding.inviteSuccess.familyOwnerDescription")}
            </p>
            <MFrame className="w-full p-0 mt-[64px]">
              <div className="auth-invite-intro">
                <h2 className="auth-invite-intro-title">
                  {t("onboarding.inviteSuccess.familyOwnerIntroTitle")}
                </h2>
                <ul className="auth-invite-intro-list">
                  <li>{t("onboarding.inviteSuccess.familyOwnerBenefit1")}</li>
                  <li>{t("onboarding.inviteSuccess.familyOwnerBenefit2")}</li>
                  <li>{t("onboarding.inviteSuccess.familyOwnerBenefit3")}</li>
                </ul>
              </div>
            </MFrame>
          </>
        )}

        {/* Continue Button */}
        <div className="confirm-footer bg-[transparent]">
          <MButton
            size="lg"
            variant="filled"
            text={t("common.getStarted")}
            className="w-full"
            onClick={handleGetStarted}
          />
        </div>
      </div>
    </div>
  );
}
